import React from 'react';
import './style.scss'
import {getWeek, getWeekFromDate} from '../orderUtil'


const WeekInputPattern = new RegExp("(20[1-9][0-9])([0][1-9]|[1-4][0-9]|5[0-3])");
const DigitInputPattern = new RegExp("^([0-9]+([.]?[0-9]+)?)$", "g");

class NPEditableCell extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        let newRow = this.props.row;
        newRow.value = event.target.value;
        let validity = this.validateData(newRow.value) === null ? false : true;

        this.props.onChangeCallback(newRow, event.target.value, validity);

    }

    validateData(value) {
        let result = false;
        if(this.props.useWeekInput){
            result = value && value.length > 0 && value.length < 7 && WeekInputPattern.test(value);
        }
        else {
            value = '' + value;
            let regexRes = value.match(DigitInputPattern);
            result = (value &&  value.length > 0) && regexRes;
        }
        return result;
    }


    render() {
        let value = this.props.row.value;
        value =  this.props.useWeekInput && value.includes('-') ? getWeekFromDate(value, false) : value;
        let valid = this.validateData(value);

        let inputStyle = {
            background: valid ? '' : '#FFB6C1'
        }

        if(this.props.editCell && this.props.useWeekInput) {
            return <input type="input"
            placeholder="WW"
            style={inputStyle}
            autoComplete="false"
            value={value}
            onClick={(e) => e.target.select()}
            onChange={(e) => {
                e.target.value = getWeek(e.target.value, true);
                this.onChange(e);
            }}
            />;
        }
        else if(this.props.editCell) {
            return <input onChange={this.onChange} style={inputStyle} autoComplete="false" value={value}/>;
        }
        else return <span>{value}</span>;

    }


}

export default NPEditableCell;